export const navigation = [
    {
        text: 'Users',
        icon: 'cn-users',
        path: '/user-list',
    },
    {
        text: 'Users View',
        icon: 'cn-users-view',
        path: '/users-view',
    },
    {
        text: 'Roles',
        icon: 'cn-roles',
        path: '/roles',
    },
    {
        text: 'Customers',
        icon: 'cn-customers',
        path: '/customers',
    },
];
